export default __webpack_public_path__ + "static/media/loader.4136a67a.gif";